
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16zm-14.452.623V23h-2.484v-6.377H13v-2.496h2.064V12.29c0-2.13 1.254-3.29 3.085-3.29.877 0 1.631.068 1.851.098v2.227h-1.263c-.996 0-1.19.49-1.19 1.212v1.59h2.383l-.31 2.496h-2.072z","fill":"currentColor"}})])
          )
        }
      }
    